import {Flex} from '@chakra-ui/react';
import {FC, PropsWithChildren} from 'react';

import {ProviderListSkeleton} from '../provider-skeleton';

interface IProps {
  conditionValue: boolean;
}

const skeletonArray = new Array(20).fill(1);

export const ProviderSliderWithSkeleton: FC<PropsWithChildren<IProps>> = ({conditionValue, children}) => {
  return (
    <>
      {conditionValue ? (
        <Flex overflow="hidden">
          <Flex overflow="hidden">
            {skeletonArray.map((_, index) => (
              <ProviderListSkeleton key={index} />
            ))}
          </Flex>
        </Flex>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
